import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalDrawer: {
    defaultMessage: 'Import Purchase Orders from CSV',
    id: 'EokLST',
    description: 'Purchase Order Import Modal Title',
  },
  createConfigStep: {
    defaultMessage: 'Upload File',
    id: 'IQ2vdL',
    description: 'Title on the first step of the import process',
  },
  createMappingStep: {
    defaultMessage: 'Match Fields',
    id: 'ZUIKqi',
    description: 'Create mapping step title message',
  },
  importResult: {
    id: 'dvNM27',
    defaultMessage: 'Import Purchase Orders',
    description: 'Title of import is processing step',
  },
  importDetailsSuccess: {
    id: 'bHZdL3',
    defaultMessage: 'We successfully processed {processed, plural, one {# purchase order} other {# purchase orders}}.',
    description: 'Successfully imported purchase orders count message',
  },
  importResultSuccess: {
    id: 'YyfGxS',
    defaultMessage: 'Purchase Orders Successfully Imported',
    description: 'Title of success import',
  },
});

export const fieldsTranslations = defineMessages({
  order_number: {
    defaultMessage: 'Order Number',
    id: 'Fvj6qq',
    description: 'Order Number purchase order import column name',
  },
  order_date: {
    defaultMessage: 'Order Date',
    id: 'wq3o8J',
    description: 'Order Date purchase order import column name',
  },
  expected_delivery_date: {
    defaultMessage: 'Expected Delivery Date',
    id: 'QibCLV',
    description: 'Expected Delivery Date purchase order import column name',
  },
  payment_terms: {
    defaultMessage: 'Payment Terms',
    id: '7MsJJG',
    description: 'Payment Terms purchase order import column name',
  },
  status: {
    defaultMessage: 'Status',
    id: 'IkEXpR',
    description: 'Status purchase order import column name',
  },
  currency_code: {
    defaultMessage: 'Currency Code',
    id: 'uxoPGJ',
    description: 'Currency Code purchase order import column name',
  },
  carrier_id: {
    defaultMessage: 'Carrier ID',
    id: 'zp7C0b',
    description: 'Carrier ID purchase order import column name',
  },
  tracking_number: {
    defaultMessage: 'Tracking Number',
    id: 'SjvPFU',
    description: 'Tracking Number purchase order import column name',
  },
  reference_number: {
    defaultMessage: 'Reference Number',
    id: 'Pcxgse',
    description: 'Reference Number purchase order import column name',
  },
  warehouse_id: {
    defaultMessage: 'Warehouse ID',
    id: 'TdF3KX',
    description: 'Warehouse ID purchase order import column name',
  },
  note_to_supplier: {
    defaultMessage: 'Note to Supplier',
    id: 'zbVA3m',
    description: 'Note to Supplier purchase order import column name',
  },
  supplier_name: {
    defaultMessage: 'Supplier Name',
    id: 'imeGe9',
    description: 'Supplier Name purchase order import column name',
  },
  supplier_email: {
    defaultMessage: 'Supplier Email',
    id: 'sCAuPP',
    description: 'Supplier Email purchase order import column name',
  },
  supplier_address_line_1: {
    defaultMessage: 'Supplier Address Line 1',
    id: 'vB7HUI',
    description: 'Supplier Address Line 1 purchase order import column name',
  },
  supplier_address_line_2: {
    defaultMessage: 'Supplier Address Line 2',
    id: '1AuL2P',
    description: 'Supplier Address Line 2 purchase order import column name',
  },
  supplier_city: {
    defaultMessage: 'Supplier City',
    id: 'k5GIMs',
    description: 'Supplier City purchase order import column name',
  },
  supplier_state: {
    defaultMessage: 'Supplier State',
    id: 'SGP228',
    description: 'Supplier State purchase order import column name',
  },
  supplier_country_code: {
    defaultMessage: 'Supplier Country Code',
    id: 'zruWS5',
    description: 'Supplier Country Code purchase order import column name',
  },
  supplier_postal_code: {
    defaultMessage: 'Supplier Postal Code',
    id: 'ocYd92',
    description: 'Supplier Postal Code purchase order import column name',
  },
  supplier_contact_name: {
    defaultMessage: 'Supplier Contact Name',
    id: 'eDx5M6',
    description: 'Supplier Contact Name purchase order import column name',
  },
  supplier_contact_phone: {
    defaultMessage: 'Supplier Contact Phone',
    id: '3Hl0oN',
    description: 'Supplier Contact Phone purchase order import column name',
  },
  sku: {
    defaultMessage: 'Product SKU',
    id: 'vBtYeq',
    description: 'Product SKU purchase order import column name',
  },
  product_name: {
    defaultMessage: 'Product Name',
    id: 'qjKYYM',
    description: 'Product Name purchase order import column name',
  },
  supplier_sku: {
    defaultMessage: 'Product Supplier SKU',
    id: 'VGkie/',
    description: 'Product Supplier SKU purchase order import column name',
  },
  quantity: {
    defaultMessage: 'Product Quantity',
    id: 'wbkmYD',
    description: 'Product Quantity purchase order import column name',
  },
  cost: {
    defaultMessage: 'Product Cost',
    id: 'hNVEvJ',
    description: 'Product Cost purchase order import column name',
  },
  tax_percent: {
    defaultMessage: 'Product Tax Percent',
    id: '7Koc+l',
    description: 'Product Tax Percent purchase order import column name',
  },
});
